import { render, staticRenderFns } from "./AdvantageItem.vue?vue&type=template&id=05559217&scoped=true&"
import script from "./AdvantageItem.vue?vue&type=script&lang=js&"
export * from "./AdvantageItem.vue?vue&type=script&lang=js&"
import style0 from "./AdvantageItem.vue?vue&type=style&index=0&id=05559217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05559217",
  null
  
)

export default component.exports